import httpClient from '../lib/http-client'

const reportGroupApi = {
  add (model) {
    return httpClient.post('/report-group', model)
  },
  findAll () {
    return httpClient.get('/report-group')
  },
  updateName (id, name) {
    return httpClient.put(`/report-group/${id}`, { name })
  },
  remove (id) {
    return httpClient.delete(`/report-group/${id}`)
  }
}

export default reportGroupApi



// WEBPACK FOOTER //
// ./src/api/report-group.js